import Vue from 'vue';
import VueCurrencyFilter from 'vue-currency-filter';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import { Tabs, Tab } from 'vue-tabs-component';
import VueCountdown from '@chenfengyuan/vue-countdown';
import VueCurrencyInput from 'vue-currency-input';

import App from './App.vue';
import router from './router';
import store from './store';
import Paginate from 'vuejs-paginate';

Vue.use(VueSweetalert2);
Vue.config.productionTip = false;
Vue.use(VueCurrencyFilter, [
    {
        symbol: '',
        thousandsSeparator: ',',
        fractionCount: 2,
        fractionSeparator: '.',
        symbolPosition: 'front',
        symbolSpacing: true,
        avoidEmptyDecimals: '',
    },
    {
        name: 'currency_not_symbol',
        symbol: '',
        thousandsSeparator: ',',
        fractionCount: 2,
        fractionSeparator: '.',
        symbolPosition: 'front',
        symbolSpacing: true,
        avoidEmptyDecimals: '',
    },
]);
Vue.use(VueCurrencyInput, {
    globalOptions: {
        locale: 'en',
        currency: null,
        allowNegative: false,
    },
});

Vue.component('tabs', Tabs);
Vue.component('tab', Tab);
Vue.component('paginate', Paginate);
Vue.component('vue-countdown', VueCountdown);

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app');
